import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuQuantumIcon extends BaseIcon {
  getChildren = () => [
    <path fill="#e45785"
          d="M22.4 16.8c5.5-3.3 11.4-5.6 17.7-6.9C37.6 3.8 33.9 0 29.9 0c-5.9 0-11 8.5-12.8 20.2 1.7-1.3 3.5-2.3 5.3-3.4zM37.6 43.1c-5.5 3.3-11.4 5.6-17.7 6.9 2.6 6.1 6.2 10 10.2 10 5.9 0 11-8.5 12.8-20.2-1.7 1-3.5 2.2-5.3 3.3z"/>,
    <g>
      <path fill="#e45785"
            d="M4 14.9C.3 21.5 8.9 33.4 23.3 41.7s29 9.7 32.8 3.3c3.8-6.5-4.9-18.5-19.3-26.8S7.8 8.5 4 14.9"/>,
    </g>,
    <g>
      <path
          d="M46.2 12.5c-5.7 0-13.7 2.2-22.2 7.1-6.7 3.9-12.4 8.8-15.9 13.5-3.2 4.4-4.2 8.5-2.8 11 2.9 5 15.9 4.7 30.6-3.8 6.7-3.8 12.4-8.7 15.9-13.5 3.2-4.4 4.2-8.5 2.8-11-1.2-2.1-4.3-3.3-8.4-3.3z"
          fill="#ffb74b"/>
    </g>,
    <path
        d="M50.3 28.8c-3.9-4.1-8.5-7.7-13.5-10.6-1.6-1-3.3-1.8-4.9-2.5-2.8 1.1-5.4 2.4-7.9 3.9-5.4 3.1-10.3 7-14.3 11.6 3.9 4.2 8.5 7.7 13.5 10.6 1.6 1 3.3 1.8 4.9 2.5 2.8-1.1 5.4-2.4 7.9-3.9 5.4-3 10.2-7 14.3-11.6z"
        fill="#e43608"/>,
    <path fill="#cc1e46"
          d="M22.4 16.8c1.9-1.1 3.7-2 5.6-2.9-2.8-1.1-5.7-1.9-8.7-2.5-1 2.9-1.7 5.7-2.1 8.8 1.6-1.3 3.4-2.3 5.2-3.4zM37.6 43.1c-1.9 1.1-3.7 2-5.6 2.9 2.8 1.1 5.7 1.9 8.7 2.5 1-2.9 1.7-5.8 2.1-8.8-1.6 1.1-3.4 2.3-5.2 3.4z"/>
    ]
  getViewBox = () => '0 0 60 60'
}
